{
	"nav": {
		"browse": "Selaa",
		"messages": "Viestit",
		"myListings": "Omat ilmoitukset",
		"watchlist": "Seurattavat",
		"settings": "Asetukset",
		"admin": "Ylläpito",
		"signIn": "Kirjaudu sisään",
		"signOut": "Kirjaudu ulos",
		"sellADisc": "Myy kiekko",
		"openMenu": "Avaa valikko",
		"theme": "Teema",
		"themeLight": "Vaalea",
		"themeDark": "Tumma",
		"themeSystem": "Järjestelmä"
	},
	"footer": {
		"tagline": "Osta ja myy käytettyjä frisbeegolf-kiekkoja.",
		"browse": "Selaa",
		"sell": "Myy",
		"reportIssue": "Ilmoita ongelmasta",
		"privacy": "Tietosuoja",
		"accessibility": "Saavutettavuus",
		"terms": "Käyttöehdot"
	},
	"betaBanner": {
		"message": "Re:Disc on julkisessa beta-vaiheessa — kehitys etenee aktiivisesti. Löysitkö jotain outoa?",
		"reportCta": "Ilmoita bugista",
		"dismiss": "Sulje"
	},
	"appReport": {
		"title": "Ilmoita ongelmasta",
		"subtitle": "Jokin rikki tai kehitysidea? Kerro meille.",
		"typeBug": "Bugi",
		"typeFeedback": "Palaute",
		"placeholder": "Kuvaile ongelma tai palautteesi…",
		"cancel": "Peruuta",
		"submit": "Lähetä",
		"submitting": "Lähetetään…",
		"thanks": "Kiitos raportistasi!",
		"failed": "Lähetys epäonnistui. Yritä uudelleen.",
		"errorNoType": "Valitse tyyppi.",
		"errorTooShort": "Kuvauksen tulee olla vähintään {{min}} merkkiä."
	}
}
